// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2W3jt","choiceBoxes":"toolbarselects_choiceBoxes__3TMR8","simpleField":"toolbarselects_simpleField__1WrrG"};